import { useTranslation } from 'react-i18next'

import { Link, returnStatuses } from '@reveni-io/reveni-ui'

import { contactMethods } from './constants'

const ContactMessage = ({ contactMethod, orderStatus, contactEmail, contactUrl, isCancellationsPortal }) => {
  const { t } = useTranslation()

  if (isCancellationsPortal || orderStatus === returnStatuses.cancelled) {
    if (contactMethod === contactMethods.email) {
      return (
        <p>
          {t('Si tienes alguna duda, contacta con nosotros escribiendo a ')}
          <Link href={`mailto:${contactEmail}`}>{contactEmail}</Link>
        </p>
      )
    } else if (contactMethod === contactMethods.url) {
      return (
        <p>
          {t('Si tienes alguna duda, contacta con nosotros entrando a ')}
          <Link target="_blank" rel="noopener noreferrer" href={contactUrl}>
            {contactUrl}
          </Link>
        </p>
      )
    } else {
      return (
        <p>
          {t('Si tienes alguna duda, contacta con nosotros entrando a ')}
          <Link target="_blank" rel="noopener noreferrer" href={contactUrl}>
            {contactUrl}
          </Link>
          {t(' o escribiendo a ')}
          <Link href={`mailto:${contactEmail}`}>{contactEmail}</Link>
        </p>
      )
    }
  }

  if (orderStatus === returnStatuses.onHold) {
    if (contactMethod === contactMethods.email) {
      return (
        <p>
          {t('Gracias por tu paciencia. Si tienes alguna duda, contacta con nosotros escribiendo a ')}
          <Link href={`mailto:${contactEmail}`}>{contactEmail}</Link>
        </p>
      )
    } else if (contactMethod === contactMethods.url) {
      return (
        <p>
          {t('Gracias por tu paciencia. Si tienes alguna duda, contacta con nosotros entrando a ')}
          <Link target="_blank" rel="noopener noreferrer" href={contactUrl}>
            {contactUrl}
          </Link>
        </p>
      )
    } else {
      return (
        <p>
          {t('Gracias por tu paciencia. Si tienes alguna duda, contacta con nosotros entrando a ')}
          <Link target="_blank" rel="noopener noreferrer" href={contactUrl}>
            {contactUrl}
          </Link>
          {t(' o escribiendo a ')}
          <Link href={`mailto:${contactEmail}`}>{contactEmail}</Link>
        </p>
      )
    }
  }

  if (contactMethod === contactMethods.email) {
    return (
      <p>
        {t('Si no las recibes o tienes alguna duda, contacta con nosotros escribiendo a ')}
        <Link href={`mailto:${contactEmail}`}>{contactEmail}</Link>
      </p>
    )
  } else if (contactMethod === contactMethods.url) {
    return (
      <p>
        {t('Si no las recibes o tienes alguna duda, contacta con nosotros entrando a ')}
        <Link target="_blank" rel="noopener noreferrer" href={contactUrl}>
          {contactUrl}
        </Link>
      </p>
    )
  } else {
    return (
      <p>
        {t('Si no las recibes o tienes alguna duda, contacta con nosotros entrando a ')}
        <Link target="_blank" rel="noopener noreferrer" href={contactUrl}>
          {contactUrl}
        </Link>
        {t(' o escribiendo a ')}
        <Link href={`mailto:${contactEmail}`}>{contactEmail}</Link>
      </p>
    )
  }
}

export default ContactMessage
